import React from 'react'

export const Download = ({ height = '16', width = '16' }) => (
	<svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M15.8289 9.9694H14.5455C14.4513 9.9694 14.3743 10.0464 14.3743 10.1405V13.4346H1.62567V10.1405C1.62567 10.0464 1.54866 9.9694 1.45455 9.9694H0.171123C0.0770053 9.9694 0 10.0464 0 10.1405V14.3758C0 14.7544 0.305882 15.0603 0.684492 15.0603H15.3155C15.6941 15.0603 16 14.7544 16 14.3758V10.1405C16 10.0464 15.923 9.9694 15.8289 9.9694Z"
			fill="#5B6880"
		/>
		<path
			d="M8.81485 7.40749H10.3956C10.5389 7.40749 10.6181 7.57219 10.5304 7.68556L8.13464 10.7166C8.11863 10.737 8.09818 10.7536 8.07483 10.7649C8.05148 10.7763 8.02585 10.7822 7.99988 10.7822C7.97391 10.7822 7.94827 10.7763 7.92493 10.7649C7.90158 10.7536 7.88113 10.737 7.86512 10.7166L5.4694 7.68342C5.3817 7.57219 5.46084 7.40749 5.60416 7.40749H7.18918L7.18918 0.171123C7.18918 0.0770057 7.26619 -8.22803e-09 7.36031 0L8.64373 1.122e-07C8.73785 1.20428e-07 8.81485 0.0770058 8.81485 0.171123L8.81485 7.40749Z"
			fill="#5B6880"
		/>
	</svg>
)
